import { SyncStatusEnum, SyncStatusKey, SyncStatusType } from "../../types/general-types";
import { SyncIcon } from "../../enum/sync.enum";

export const syncStates: Record<SyncStatusKey, SyncStatusType> = {
  syncing: {
    key: SyncStatusEnum.syncing,
    icon: SyncIcon.syncAll,
    messageKey: "syncing",
    actions: null,
  },

  synced: {
    key: SyncStatusEnum.synced,
    icon: SyncIcon.checkCircle,
    messageKey: "synced",
    actions: null,
  },

  failed: {
    key: SyncStatusEnum.failed,
    icon: SyncIcon.xCircle,
    messageKey: "error",
    actions: ["retry"],
  },

  noConnector: {
    key: SyncStatusEnum.noConnector,
    icon: SyncIcon.xCircle,
    messageKey: "error",
    actions: ["retry", "connect"],
  },

  noBasiqUser: {
    key: SyncStatusEnum.noBasiqUser,
    icon: SyncIcon.xCircle,
    messageKey: "needToConnectToBasiq",
    actions: ["consent"],
  },

  noBasiqConsent: {
    key: SyncStatusEnum.noBasiqConsent,
    icon: SyncIcon.xCircle,
    messageKey: "needToConsentToBasiq",
    actions: ["consent"],
  },

  noConnection: {
    key: SyncStatusEnum.noConnection,
    icon: SyncIcon.xCircle,
    messageKey: "noConnectionFound",
    actions: ["connect"],
  },

  noConnectionRefresh: {
    key: SyncStatusEnum.noConnectionRefresh,
    icon: SyncIcon.xCircle,
    messageKey: "connectionRefreshFailed",
    actions: ["retry", "connect"],
  },

  basiqJobFetchFail: {
    key: SyncStatusEnum.basiqJobFetchFail,
    icon: SyncIcon.xCircle,
    messageKey: "couldNotRetrieveData",
    actions: ["retry"],
  },

  dataFetchFail: {
    key: SyncStatusEnum.dataFetchFail,
    icon: SyncIcon.xCircle,
    messageKey: "dataFetchFailed",
    actions: ["retry"],
  },

  cantValidateTransactions: {
    key: SyncStatusEnum.cantValidateTransactions,
    icon: SyncIcon.xCircle,
    messageKey: "cantValidateTransactions",
    actions: [],
  },

  cantMapTransactions: {
    key: SyncStatusEnum.cantMapTransactions,
    icon: SyncIcon.xCircle,
    messageKey: "cantMapTransactions",
    actions: [],
  },

  noTransactionsToProcess: {
    key: SyncStatusEnum.noTransactionsToProcess,
    icon: SyncIcon.xCircle,
    messageKey: "noTransactionsToProcess",
    actions: [],
  },

  cantSaveTransactions: {
    key: SyncStatusEnum.cantSaveTransactions,
    icon: SyncIcon.xCircle,
    messageKey: "cantSaveTransactions",
    actions: [],
  },

  noTransactionsToValidate: {
    key: SyncStatusEnum.noTransactionsToValidate,
    icon: SyncIcon.xCircle,
    messageKey: "noTransactionsToValidate",
    actions: [],
  },

  cantSaveSourceTransactions: {
    key: SyncStatusEnum.cantSaveSourceTransactions,
    icon: SyncIcon.xCircle,
    messageKey: "cantSaveSourceTransactions",
    actions: [],
  },

  cantSaveCategories: {
    key: SyncStatusEnum.cantSaveCategories,
    icon: SyncIcon.xCircle,
    messageKey: "cantSaveCategories",
    actions: [],
  },

  cantPullTransactions: {
    key: SyncStatusEnum.cantPullTransactions,
    icon: SyncIcon.xCircle,
    messageKey: "cantPullTransactions",
    actions: [],
  },

  cantSaveCBAT: {
    key: SyncStatusEnum.cantSaveCBAT,
    icon: SyncIcon.xCircle,
    messageKey: "cantSaveCBAT",
    actions: [],
  },

  unknownError: {
    key: SyncStatusEnum.unknownError,
    icon: SyncIcon.xCircle,
    messageKey: "unknownError",
    actions: [],
  },
};
